export default {
  english: {
    title: 'Cookie list',
    cookiesSubgroup: 'Host name',
    cookies: 'Cookies',
    cookiesUsedBy: 'Used by',
    firstParty: 'Publisher (1st Party)',
    thirdParty: 'Third partners (3rd Party)',
  },
  french: {
    title: 'Liste des cookies',
    cookiesSubgroup: 'Nom de domaine',
    cookies: 'Cookies',
    cookiesUsedBy: 'Utilisés par',
    firstParty: 'Annonceur (1st Party)',
    thirdParty: 'Partenaires tiers (3rd Party)',
  },
  arabic: {
    title: 'قائمة ملفات تعريف الارتباط',
    cookiesSubgroup: 'اسم المضيف',
    cookies: 'بسكويت',
    cookiesUsedBy: 'استعمل من قبل',
    firstParty: '(1st Party) الناشر',
    thirdParty: '(3rd Party) الشركاء الثالث',
  },
  hebrew: {
    title: 'רשימת עוגיות',
    cookiesSubgroup: 'שם אורח',
    cookies: 'עוגיות',
    cookiesUsedBy: 'בשימוש על ידי',
    firstParty: 'מפרסמים (צד ראשון) / מוציא לאור (צד ראשון)',
    thirdParty: 'שותפים שלישיים (צד שלישי)',
  },
  persian: {
    title: 'لیست کوکی ها',
    cookiesSubgroup: 'نام میزبان',
    cookies: 'کوکی ها',
    cookiesUsedBy: 'استفاده شده توسط',
    firstParty: 'ناشر (پارت اول)',
    thirdParty: 'شرکای ثالث (شخص ثالث)',
  },
}
